module.exports = new Promise((resolve, reject) => {
  const remoteUrl = window.remoteAppUrl;
  const remoteScope = 'ciam_user_registration';

  const resolveRemote = () => {
    const container = window[remoteScope];
    if (!container) {
      reject(new Error('Module Federation container "ciam_user_registration" was not found on window.'));
      return;
    }

    resolve({
      get: container.get.bind(container),
      init: (shareScope) => {
        try {
          return container.init(shareScope);
        } catch (error) {
          return undefined;
        }
      },
    });
  };

  if (!remoteUrl) {
    reject(new Error('window.remoteAppUrl is not defined.'));
    return;
  }

  if (window[remoteScope]) {
    resolveRemote();
    return;
  }

  const existingScript = document.querySelector('script[data-remote-scope="' + remoteScope + '"]');
  if (existingScript) {
    existingScript.addEventListener('load', resolveRemote, { once: true });
    existingScript.addEventListener('error', () => reject(new Error('Failed to load remote entry from ' + remoteUrl)), { once: true });
    return;
  }

  const script = document.createElement('script');
  script.src = remoteUrl;
  script.type = 'text/javascript';
  script.async = true;
  script.dataset.remoteScope = remoteScope;
  script.onload = resolveRemote;
  script.onerror = () => reject(new Error('Failed to load remote entry from ' + remoteUrl));
  document.head.appendChild(script);
});